import { CommonGet, CommonPost } from '../../helpers/HttpClient';

export default {
  getAllGroups,
  GenerateSKUCode,
  saveDetails,
  GetDetailsBySKUMasterID,
  UpdateSKUData,
  findExistsRecord,
  GetSKUTypes,
  GetMeasuringUnits,
  GetSKUDetails,
  GetSKUDataByTypeAndCategory,
  getAllFactoriesByGroupID,
  GetSKUCategoryNamesByID,
  getSKUTCategoriesDropdown
}

async function getAllGroups() {
  let response = await CommonGet('/api/Factory/GetAllActiveGroups', null);
  let groupArray = []
  for (let item of Object.entries(response.data)) {
    groupArray[item[1]["groupID"]] = item[1]["groupName"]
  }
  return groupArray;
}

async function getAllFactoriesByGroupID(groupID) {
  let response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
  let factoryArray = []
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"]
  }
  return factoryArray;
}

async function GenerateSKUCode(model) {
  const response = await CommonPost('/api/SKUMaster/GenerateSKUCode', null, model);
  if (Array.isArray(response.data) && response.data.length > 0) {
    return response.data[0].skuMasterCode;
  }
  return null;
}

async function findExistsRecord(model) {
  const response = await CommonPost('/api/SKUMaster/FindExistsRecord', null, model);
  return response;
};

async function saveDetails(model) {
  const response = await CommonPost('/api/SKUMaster/SaveSKUData', null, model);
  return response;
};

async function GetSKUTypes() {
  let response = await CommonGet('/api/BudgetCode/GetAllBudgetCodes', null);
  let groupArray = []
  for (let item of Object.entries(response.data)) {
    groupArray[item[1]["budgetCodeID"]] = item[1]["budgetCodeName"]
  }
  return groupArray;
}

async function GetMeasuringUnits() {
  let response = await CommonGet('/api/SKUMaster/GetMeasuringUnits', null);
  let groupArray = []
  for (let item of Object.entries(response.data)) {
    groupArray[item[1]["measuringUnitID"]] = item[1]["measuringUnitName"]
  }
  return groupArray;
}

async function GetSKUDetails(model) {
  const response = await CommonPost('/api/SKUMaster/GetSKUDetails', null, model);
  return response;
};

async function GetDetailsBySKUMasterID(skuMasterID) {
  let response = await CommonPost('/api/SKUMaster/GetDetailsBySKUMasterID', "skuMasterID=" + parseInt(skuMasterID))
  return response.data;
}

async function GetSKUDataByTypeAndCategory(modelCode) {
  const response = await CommonPost('/api/SKUMaster/GetSKUDataByTypeAndCategory', null, modelCode);
  return response;
}

async function UpdateSKUData(model) {
  const response = await CommonPost('/api/SKUMaster/UpdateSKUData', null, model);
  return response;
}

async function GetSKUCategoryNamesByID(groupID,factoryID ,sKUTypeID) {
  let response = await CommonGet('/api/SKUCategory/GetSKUCategoryNamesByEstateIDFactoryID', "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID) + "&sKUTypeID=" + parseInt(sKUTypeID)); 
  let categoryArray = [];
  for (let item of Object.entries(response.data)) {
    categoryArray[item[1]["skuCategoryID"]] = item[1]["skuCategoryName"];
  }
  return categoryArray;
}

async function getSKUTCategoriesDropdown(groupID,factoryID,sKUTypeID) {
  let response = await CommonGet('/api/SKUCategory/GetSKUCategoryNamesByEstateIDSKUTypeID', "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID)+ "&sKUTypeID=" + parseInt(sKUTypeID)); 
  let categoryArray = [];
  for (let item of Object.entries(response.data)) {
    categoryArray[item[1]["skuCategoryID"]] = item[1]["skuCategoryName"];
  }
  return categoryArray;
}